import { action, runInAction, makeObservable } from "mobx";
import InformacoesProcessoService from "./InformacoesProcessoService";
import { PecaDto } from "../modelo/dto/PecaDto";
import ProcessoStore from "../store/ProcessoStore";
import { Processo } from "../modelo";
import MinutaApi from "../api/MinutaApi";

class PeticaoService {
    constructor() {
        makeObservable(this, {
            carregarPeticoes: action
        });
    }

    async carregarPeticoes(processo: Processo) {
        const idProcesso = processo.identificadorProcesso;

        // preencher minutaPeticoes
        processo.minutas.forEach(minuta => {
                minuta.minutaPeticoes = [];
                MinutaApi.listarVinculosPeticaoMinuta(minuta.numero).then(vinculosPeticaoMinuta => {
                    vinculosPeticaoMinuta.forEach(vinculo => {
                        runInAction(() => {
                            minuta.minutaPeticoes.push({
                                apreciada: false,
                                id: vinculo.numeroMinutaPeticao,
                                identificadorDocumento: vinculo.codigoDocumento,
                                identificadorPeticao: vinculo.codigoIdentificacaoUnicoPeticao
                            });
                        });
                    });
                });
        });

        let peticoesPendentes = await InformacoesProcessoService.consultarPeticoes(idProcesso);
        peticoesPendentes = peticoesPendentes.filter((p) => {
            return (p.codigoPeticaoStatus != 7 && p.codigoPeticaoStatus != 6)
        });        
        peticoesPendentes = await Promise.all(peticoesPendentes.map(async peticao => {
            const docPeticaoPendente = await InformacoesProcessoService.consultarDocumentoPorId(idProcesso, peticao.id) as any;
            peticao.idUnicoDocumento = docPeticaoPendente.idUnicoDocumento;
            peticao.selecionado = false;
            peticao.vinculo = this.consultaVinculo(peticao, processo);
            return peticao;
        }));

        const resultados = await Promise.all(peticoesPendentes);
        return {
            peticoesPendentes: resultados,
        };
    }

    consultaVinculo = (peticao: PecaDto, processo: Processo) => {
        const idProcesso = processo.identificadorProcesso;
        const resultado = [];
        const indexProcesso = ProcessoStore._processos.findIndex(proc => proc.identificadorProcesso === idProcesso);

        ProcessoStore._processos[indexProcesso].minutas?.forEach(async minuta => {
            minuta.minutaPeticoes?.filter(petVinculada => peticao.id == petVinculada.identificadorDocumento).map(_peticoesVinculadas => {
                resultado.push({
                    texto: minuta.tipo.descricao,
                    id: minuta.numero
                });
            })
        });
        return resultado;
    }
}


export default new PeticaoService();